/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_View_OrdersInputs */

const vi_dashboard_sales_view_orders = /** @type {(inputs: Dashboard_Sales_View_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem đơn của tôi`)
};

/**

* @param {Dashboard_Sales_View_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_view_orders = /** @type {((inputs?: Dashboard_Sales_View_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_View_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_view_orders(inputs)
});